module.exports = function arrayNext(array, currentItem) {
    var len = array.length;
    var newIndex = array.indexOf(currentItem) + 1;
    if (newIndex > (len - 1)) newIndex = 0;
    return array[newIndex];
};



//////////////////
// WEBPACK FOOTER
// /home/jtsymon/code/govhack-2017-game/node_modules/array-next/array-next.js
// module id = 250
// module chunks = 0